import { useAsyncData } from '#imports'
import { computed } from 'vue'

import { useAlgoliaSearchOptions } from '@backmarket/nuxt-layer-algolia/useAlgoliaSearchOptions'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import algoliasearch from 'algoliasearch'

import { getTradeInModelPath } from '../../utils/getTradeInModelPath/getTradeInModelPath'
import { useBuybackCategories } from '../useBuybackCategories/useBuybackCategories'
import {
  type AlgoliaHit,
  algoliaHitToBuybackProduct,
  getBuybackSearchConfiguartion,
} from '../useBuybackSearch'

export async function useSeoProductsByCategory(
  category: string,
  brand?: string,
) {
  const algoliaSearchOption = useAlgoliaSearchOptions('buyback')
  const locale = useI18nLocale()
  const { getTitleByCategory } = useBuybackCategories()

  const {
    data: products,
    pending: isLoading,
    error,
  } = await useAsyncData(
    `seo-products-${category}${brand ? `-${brand}` : ''}`,
    async () => {
      const config = await getBuybackSearchConfiguartion(
        'descending-gmv-search',
      )

      if (!config.data.value?.indexName) {
        return []
      }

      const algoliaIndex = algoliasearch(
        'dummy_app_id',
        'dummy_key',
        algoliaSearchOption,
      ).initIndex(config.data.value.indexName)

      let filters: string
      if (brand) {
        filters = `category:"${category}" AND brand:"${brand}"`
      } else if (category === 'smartphone') {
        filters = `category:"${category}" AND NOT brand:"Apple"`
      } else {
        filters = `category:"${category}"`
      }

      const searchResult = await algoliaIndex.search<AlgoliaHit>('', {
        filters,
        hitsPerPage: 1000,
      })

      return searchResult.hits.map(algoliaHitToBuybackProduct)
    },
    {
      default: () => [],
    },
  )

  const seoSections = computed(() => ({
    title: getTitleByCategory(brand || category),
    links: products.value.map((p) => ({
      label: p.model,
      url: getTradeInModelPath({
        locale,
        category: p.category,
        slug: p.slug,
      }),
    })),
  }))

  return {
    seoSections,
    isLoading,
    error,
  }
}
